import { storage } from '../compat/storage';

export async function fetchLastWatched() {
  return storage.getLastWatched();
}
